<template>
    <div id="main">
        <!-- CONTAINER DE ALERTAS -->
        <alert-container :messages="msgs" />
        <div class="listing-header">
            <div class="title-breadcrumb">
                <h1 class="title">
                    {{ $t("novo") + " " + $t('ramo') }}
                </h1>
            </div>
            <div class="header-buttons">
                <button
                    class="delete-btn"
                    type="button"
                    tag="button"
                    @click="voltar"
                >
                    {{ $t("voltar") }}
                </button>
                <button class="save-btn" type="button" @click="save">
                    {{ $t("salvar") }}
                </button>
            </div>
        </div>

        <div class="form-columns-fit mt-5">
            <div class="columns is-flex-wrap">
                <div class="column is-12">
                    <div class="columns is-flex-wrap">
                        <div class="column is-3">
                            <v-input 
                                :id="generateId(22)"
                                ref="idErpInput"
                                v-model="ramo.idramoerp"
                                placeholder="placeholder-preencha"
                                :maxlength="30"
                                title="codigo"
                                required
                                tooltipLabel="cod-ref"
                                :invalid="!ramo.idramoerp"
                                uppercase
                            />
                        </div>

                        <div class="column is-9">
                            <v-input
                                v-model="ramo.descricao"
                                :id="'descricao'"
                                placeholder="ramo-placeholder"
                                :maxlength="50"
                                title="descricao-ramo"
                                :msg="'msg-campo-obrigatorio'"
                                :invalid="!ramo.descricao"
                                ref="descricaoInput"
                                required
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import RamoValidation from "@/services/validations/RamoValidation";
import RamoService from "@/services/RamoService";
import Message from "@/models/Message";

export default {
    data() {
        return {
            service: null,
            validation: null,
            isSaving: false,
            ramo: {
                id: null,
                idramoerp: null,
                descricao: null
            },
            msgs: [],
        };
    },
    created() {
        this.service = new RamoService(this.$http, this.$router);
        this.validation = new RamoValidation(this.msgs);
    },
    methods: {
        voltar() {
            this.$emit("voltar")
        },
        save() {
            this.isSaving = true;
            this.ramo = this.mapTosave(this.ramo);

            if (this.validation.validate(this.ramo, this.$refs)) {
                this.service.save(this.ramo)
                    .then((value) => {
                        if (value.message == null) {
                            this.ramo.id = value.content.id;

                            this.msgs.push(new Message("success", 'msg-success-cadastrar', true));

                            let objEmit = {
                                'origem': 'ramo',
                                'obj': { id: this.ramo.id, label: this.ramo.descricao } 
                            };

                            setTimeout(() => {
                                this.$emit('sucesso', objEmit);
                            }, 1000);
                        } else {
                            if (this.$t(value.message)) {
                                this.msgs.push(
                                    new Message("alert", value.message, true)
                                );
                            } else {
                                this.msgs.push(
                                    new Message(
                                        "error",
                                        "msg-problema-realizar-acao",
                                        true
                                    )
                                );
                            }
                        }
                    })
                    .catch((e) => {
                        if (e.body.status == 500) {
                            this.msgs.push(
                                new Message("alert", e.body.message, true)
                            );
                        } else {
                            console.error("Erro ao salvar: " + e);
                            this.msgs.push(
                                new Message("error", "msg-erro-salvar", true)
                            );
                        }
                    })
                    .finally(() => {
                        this.isSaving = false;
                    });
            }
        },
        generateId(numberId) {
            return this.$route.name + "-contato-" + numberId;
        }
    }
}
</script>

<style lang="scss" scoped>
#main {
    padding: 20px 20px;
    background-color: $sovis-white;
}
</style>